define('home/templates/motdAlert',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.persistentAlert : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"alert--success\">\n<div class=\"padding-default\">\n<div class=\"text-center spacing-narrow\">\n<span class=\"icon icon-megaphone icon__position spacing-right-small\"></span>\n<strong class=\"spacing-right\">"
    + alias2(alias1((depth0 != null ? depth0.motdTitle : depth0), depth0))
    + "</strong>\n<a\nhref=\""
    + alias2(alias1((depth0 != null ? depth0.motdLink : depth0), depth0))
    + "\"\nclass=\"button button-inverted -hover-opaque text-medium\"\ntarget=\"_blank\"\nrel=\"noopener noreferrer\"\n>Learn more &raquo;</a>\n</div>\n</div>\n</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"alert--brand\">\n<div class=\"padding-default\">\n<div class=\"text-center spacing-narrow\">\n<span class=\"icon icon-megaphone icon__position spacing-right-small\"></span>\n<strong class=\"spacing-right\">"
    + alias2(alias1((depth0 != null ? depth0.motdTitle : depth0), depth0))
    + "</strong>\n<a href=\""
    + alias2(alias1((depth0 != null ? depth0.motdLink : depth0), depth0))
    + "\" class=\"button button-inverted -hover-opaque text-medium\">Learn more &raquo;</a>\n<button class=\"link-inverted spacing-left\" data-action=\"close-alert\">\n<span class=\"icon-cancel\"></span>\n</button>\n</div>\n</div>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},(depth0 != null ? depth0.hideAlert : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true})

});
